import React from 'react';

import type {RuleFragment} from '../../../generated/types';
import {EntitySeo} from '../../../lib/seo';
import {buildUrl} from '../../../lib/routes';
import {ruleDescription, ruleKindText} from './rule-seo-text';

export const RuleSeo: React.FC<{item: RuleFragment}> = ({item}) => {
	const crumbs = [...(item.parent ? [item.parent] : []), item].map((rule) => ({
		name: rule.title,
		path: buildUrl('rule', {id: rule.id}),
	}));
	return (
		<EntitySeo
			entity={item}
			section="rules"
			kind={ruleKindText(item).toLowerCase()}
			description={ruleDescription(item)}
			path={buildUrl('rule', {id: item.id})}
			og={{kind: 'rule'}}
			crumbs={crumbs}
		/>
	);
};
